<template>
  <div class="upload-excel payment-upload-excel-file">
    <el-upload
      v-if="!uploading"
      :ref="'upload_'+ type"
      action="#"
      drag
      :auto-upload="false"
      :limit="limitNum"
      accept=".xls,.xlsx"
      :on-change="handleFile.bind(this,type)"
      :on-remove="handleRemove.bind(this,type)"
      :on-exceed="handleFileExceed.bind(this,type)"
      :file-list="fileList"
    >
      <div>
        <i class="el-icon-upload" />
        <div class="el-upload__text">Drag here or <em style="color:#3855F1"> click to upload </em></div>
        <!-- <el-button size="small" type="prima
        ry">{{ $t('bdManage.click_upload_template') }}</el-button>
        <div slot="tip" class="el-upload__tip">Only excel files can be uploaded</div> -->
      </div>

    </el-upload>
    <div v-if="uploading" class="parse">
      Parsing
    </div>
    <Progress :progress="uploadingProgress" />
  </div>

</template>
<script>
// import { uploadFileShowProgress } from '@/api/components/upload'
import { uploadPaymentTransTemplateExcel } from '@/api/online-transaction/online-transaction'
export default {
  name: 'UpdateFile',
  components: {
    Progress: () => import('@/views/components/Progress.vue')
  },
  props: {
    limitNum: {
      type: Number,
      default: 1000
    },
    type: {
      type: String,
      default: ''
    },
    referenceBatchNo: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      fileList: [],
      removeFiles: [],
      uploadingProgress: 0,
      uploading: false
    }
  },
  methods: {
    handleFile(type, file, fileList) {
      if (this.uploading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }
      this.uploading = true
      const params = {}
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('reference_batch_no', this.referenceBatchNo)
      params.data = formData
      // 上传进度，固定到大概95%，等后台响应成功显示100%
      params.onUploadProgress = (progressEvent) => {
        const value = Math.floor((progressEvent.loaded * 100) / (progressEvent.total * 1.05))
        this.uploadingProgress = value
      }

      uploadPaymentTransTemplateExcel(params).then(res => {
        if (res.code === 10000) {
          if (this.removeFiles.includes(file.uid)) {
            return
          }
          this.$message.success('Parsing succeeded')
          this.$emit('templateFileSuccess', res.data)
          this.fileList = []
          this.uploadingProgress = 100
          setTimeout(() => {
            this.uploadingProgress = 0
          }, 500)
        }
      }).catch((err) => {
        // 上传失败，文件还是会显示，要移除文件
        console.error('err', err)
        const uid = file.uid
        const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
        if (idx !== -1) {
          this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
        }
      }).finally(() => {
        this.uploading = false
        this.uploadingProgress = 0
      })
    },
    handleRemove(type, file, fileList) {
      this.fileList = fileList
      if (file.status === 'ready') {
        // 重置进度条
        this.uploadingProgress = 0
        // 重置上传状态
        this.uploading = false
        // 正在上传中，移除，添加记录，等上传成功之后不进行处理
        this.removeFiles.push(file.uid)
      }
    },
    handleFileExceed(type) {
      if (this.fileList[type].length >= this.limitNum) {
        this.$message.warning(`The current limit is ${this.limitNum}, please delete and upload again!`)
        return
      }
    }
  }
}
</script>
<style>
.payment-upload-excel-file .el-upload-dragger{
  width: 300px;
  height: 130px;
}
.payment-upload-excel-file .el-icon-upload{
    font-size: 34px;
    color: #D3D7DF;
    margin: 28px 0 16px;
    line-height: 1;
}
</style>

<style lang="scss" scoped>
.upload-excel{

  display: inline-block;
}
.btn-update{
  margin-left: 10px;
}
.upload-container{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    cursor: pointer;
    line-height: 100px;
    vertical-align: top;
    font-size: 12px;
    color: #8c939d;
    .icon-add{
      font-size: 8px;
    }
}
.parse{
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
}
</style>
